import { useEffect, useState } from 'react';
import { subscribeFinanceSummary } from '@services/registry';

export function useFinanceSummary({ tenantId }) {
    const [summary, setSummary] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!tenantId) {
            setSummary(null);
            setLoading(false);
            return;
        }
        setLoading(true);
        let unsub = () => {};
        try {
            unsub = subscribeFinanceSummary({
                tenantId,
                onNext: (next) => {
                    setSummary(next || {});
                    setLoading(false);
                    setError(null);
                },
                onError: (err) => {
                    console.error(err);
                    setError(err);
                    setLoading(false);
                },
            });
        } catch (e) {
            setError(e);
            setLoading(false);
        }
        return () => unsub?.();
    }, [tenantId]);

    return { summary, loading, error };
}

